import { render } from "./VariantSLAModal.vue?vue&type=template&id=63aa22d2&scoped=true"
import script from "./VariantSLAModal.vue?vue&type=script&lang=js"
export * from "./VariantSLAModal.vue?vue&type=script&lang=js"

import "./VariantSLAModal.vue?vue&type=style&index=0&id=63aa22d2&scoped=true&lang=scss"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63aa22d2"]])

export default __exports__
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QField from 'quasar/src/components/field/QField.js';import ClosePopup from 'quasar/src/directives/close-popup/ClosePopup.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QCardSection,QField});qInstall(script, 'directives', {ClosePopup});
